import { FC } from 'react'

import { ISvgClass } from '../interface'

const OnlypaySimbolIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 78.000000 79.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g
        transform="translate(0.000000,79.000000) scale(0.100000,-0.100000)"
        fill="inherit"
        stroke="inherit"
      />
    </svg>
  )
}

export default OnlypaySimbolIcon
